// Event layer: pushes to window.dataLayer; forwards to GA4/Plausible only after analytics consent.
export const EVENTS = {
  HERO_DEMO_CLICK: "hero_demo_click",
  PRODUCT_SELECTED: "product_selected",
  PROBLEM_SELECTED: "problem_selected",
  BUYER_SELECTED: "buyer_selected",
  SCENARIO_STARTED: "scenario_started",
  SCENARIO_COMPLETED: "scenario_completed",
  HEIMDALL_OPENED: "heimdall_opened",
  ASSESSMENT_STARTED: "governance_assessment_started",
  ASSESSMENT_COMPLETED: "governance_assessment_completed",
  BOARDPACK_REQUESTED: "board_pack_requested",
  DEMO_FORM_STARTED: "demo_form_started",
  DEMO_FORM_COMPLETED: "demo_form_completed",
  TECH_ASSESSMENT_REQUESTED: "technical_assessment_requested",
};

const CONSENT_KEY = "norse3_cookie_prefs_v1";

export function track(event, props = {}) {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ts: Date.now(), ...props });
    if (typeof window.gtag === "function") window.gtag("event", event, props);
    if (typeof window.plausible === "function") window.plausible(event, { props });
  } catch (e) { /* no-op */ }
}

export function trackPageView(path) {
  if (typeof window.gtag === "function") window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
  if (typeof window.plausible === "function") window.plausible("pageview");
}

function hasConsent() {
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY) || "{}").analytics === true; } catch (e) { return false; }
}

// Configure in frontend/.env: REACT_APP_GA4_ID=G-XXXX and/or REACT_APP_PLAUSIBLE_DOMAIN=norse3.com
let _inited = false;
export function initAnalytics() {
  if (_inited || typeof document === "undefined" || !hasConsent()) return;
  _inited = true;
  const ga4 = process.env.REACT_APP_GA4_ID;
  const plausibleDomain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;

  if (ga4) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ga4, { anonymize_ip: true, send_page_view: false });
  }

  if (plausibleDomain) {
    const p = document.createElement("script");
    p.defer = true;
    p.setAttribute("data-domain", plausibleDomain);
    p.src = "https://plausible.io/js/script.manual.js";
    document.head.appendChild(p);
    window.plausible = window.plausible || function () { (window.plausible.q = window.plausible.q || []).push(arguments); };
  }
  trackPageView(window.location.pathname);
}
